const Menu = {
  /**
   * Create
   * @return {void}
   */
  create(node, props) {
    this.container = node;
    this.props = props;
    this.$storeForm = $(this.container).find('.js-menu-item-store');

    this.createListeners();
  },

  /**
   * Create event listeners
   * @return {void}
   */
  createListeners() {
    $(this.container).find('.js-menu-item').on('blur', 'input, textarea', (e) => {
      const $row = this.getRowForEventTarget(e);
      const api = this.getApiForRow($row);

      this.updateRow($row, api);
    });

    $(this.container).find('.js-menu-item').on('change', 'input[type="checkbox"]', (e) => {
      const $row = this.getRowForEventTarget(e);
      const api = this.getApiForRow($row);

      this.updateRow($row, api);
    });

    this.$storeForm.on('change', '.js-menu-item-select', (e) => {
      const $select = $(e.currentTarget);
      this.setTitleField($select);
      this.toggleUrlField($select.val() === 'custom_url');
    });

    this.$storeForm.on('blur', '.js-menu-item-title', (e) => {
      const el = e.currentTarget;
      if (el.className.indexOf('is-touched') < 0) {
        el.className = `${el.className} is-touched`;
      }
    });
  },

  /**
   * Get row element based on the event
   * @param  {object} event
   * @return {object}
   */
  getRowForEventTarget(event) {
    return $(event.currentTarget).parents('.js-menu-item');
  },

  /**
   * Return the API endpoint for the row
   * @param  {object} $row
   * @return {object}
   */
  getApiForRow($row) {
    return $row.data('menu-update-api');
  },

  /**
   * Change title field based on the selected item
   *
   * @param {object} $select
   * @return {void}
   */
  setTitleField($select) {
    const $selectedOption = $select.find('option:selected');
    const $titleField = this.$storeForm.find('.js-menu-item-title');

    // Title can only be updated if the user didn't touch it
    const titleCanBeUpdated = (
      !$titleField.hasClass('is-touched')
      || $titleField.val().length === 0
    );

    if (!$selectedOption.length || !titleCanBeUpdated) {
      return;
    }

    const title = $selectedOption.data('title');

    $titleField.val(title);
  },

  toggleUrlField(state) {
    this.$storeForm.find('.js-menu-item-url').toggle(state);
  },

  /**
   * Call an update on the row, this will retrieve all input values and call the API
   * @param  {object} $row
   * @param  {string} api
   * @return {void}
   */
  updateRow($row, api) {
    const values = {};

    $row
      .eq(0)
      .find('input, textarea, input[type="radio"], input[type="checkbox"]')
      .toArray()
      .forEach((input) => {
        let { value } = input;

        if (input.type === 'checkbox') {
          value = input.checked;
        }

        values[input.getAttribute('name')] = value;
      });

    this.update(values, api);
  },

  /**
   * Call update on the API
   * @param  {object} values
   * @param  {string} api
   * @return {void}
   */
  update(values, api) {
    window.axios({
      method: 'post',
      url: api,
      data: Object.assign(values, {
        _method: 'PUT',
      }),
    })
      .then(() => {
        window.toaster.show('Menu item titel is opgeslagen', 2000);
      })
      .catch(() => {
        window.toaster.show('Er was een probleem bij het opslaan', 3000, 'danger');
      });
  },
};

export default Menu;
